export default __webpack_public_path__ + "bfefaa18fd11e022d7ef2f7c1407871d.png";